<div class="form-inline">
    <div class="form-group">
        <input
            type="number"
            [(ngModel)]="yy"
            min="1970"
            max="9999"
            class="form-control form-control-sm"
            (ngModelChange)="changeYear($event)">
        <span class="mx-1">-</span>
        <input
            type="number"
            [(ngModel)]="mm"
            min="1"
            max="12"
            class="form-control form-control-sm"
            (ngModelChange)="changeMonth($event)">
    <!--
        <span class="mx-1">-</span>
        <input
            type="number"
            [(ngModel)]="dd"
            min="1"
            max="31"
            class="form-control form-control-sm"
            (ngModelChange)="changeDay($event)">
    -->
    </div>
</div>